/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export const navigationHeaderHeight = {
    default: {lg: '5.5rem', xl: '6rem'},
    messageBar: {base: '6.75rem', lg: '7.75rem', xl: '8.25rem'}
}

export default {
    baseStyle: {
        dialog: {
            // reset chakra styles
            maxH: null,
            // iOS 100vh equals the large viewport - that is as if all UA interfaces are retracted,
            // so we need to use the 100% to take into account the currently expanded UI interface elements
            maxHeight: '100%'
        },
        header: {
            paddingTop: 1,
            paddingRight: [4, 4, 6, 6],
            paddingBottom: 1,
            paddingLeft: [4, 4, 6, 6],
            boxShadow: 'base'
        },
        body: {
            padding: [4, 4, 6, 6]
        },
        footer: {
            paddingTop: 6,
            paddingRight: [4, 4, 6, 6],
            paddingBottom: 11,
            paddingLeft: [4, 4, 6, 6]
        }
    },
    variants: {
        navigation: ({headerVariant = 'default'}) => ({
            dialogContainer: {
                top: navigationHeaderHeight[headerVariant]
            },
            dialog: {
                // reset chakra styles
                bg: null,
                height: null,
                // custom styles
                marginTop: navigationHeaderHeight[headerVariant],
                pointerEvents: 'none'
            },
            overlay: {
                // start overlay below the header
                top: {
                    base: '0',
                    ...navigationHeaderHeight[headerVariant]
                }
            },
            header: {
                // reset chakra styles
                px: null,
                py: null,
                fontSize: null,
                fontStyle: null,
                // reset base styles
                paddingTop: null,
                paddingRight: null,
                paddingBottom: null,
                paddingLeft: null,
                boxShadow: null,
                // mobile header styles - back btn, title, close btn
                display: {base: 'flex', lg: 'none'},
                flexDirection: 'row',
                alignItems: 'center',
                backgroundColor: 'stokkeCore.white',
                pointerEvents: 'auto'
            },
            body: {
                // reset chakra styles
                px: null,
                py: null,
                // reset base styles
                padding: null,
                // custom styles
                display: 'flex',
                flexDirection: {base: 'column', lg: 'row'},
                flex: {base: '1', lg: '0 1 auto'},
                height: {base: '100%', lg: 'auto'},
                backgroundColor: 'stokkeCore.white',
                pointerEvents: 'auto',
                // this is to match the header workaround that prevents header shifts on modal/drawer open
                paddingInlineEnd: {lg: 'var(--removed-body-scroll-bar-size)'}
            },
            footer: {
                // reset chakra styles
                px: null,
                py: null,
                // reset base styles
                paddingTop: null,
                paddingRight: null,
                paddingBottom: null,
                paddingLeft: null,
                // custom styles
                display: {base: 'flex', lg: 'none'},
                flexDirection: 'row',
                justifyContent: 'center',
                paddingX: 4,
                paddingY: 2,
                gap: 4,
                backgroundColor: 'stokkeCore.white',
                pointerEvents: 'auto',
                borderTop: '1px',
                borderColor: 'stokkeCore.black'
            }
        }),
        search: {
            body: {
                // reset base styles
                padding: null,
                py: {base: 6, lg: 10},
                px: 4
            }
        }
    }
}
